export default __webpack_public_path__ + "static/media/UofTML_2021_UncertaintyDeepQ.3f063026.pdf";